module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMTE0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dXNlIHhsaW5rOmhyZWY9IiNwYXRoMF9zdHJva2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiLz48ZGVmcz48cGF0aCBpZD0icGF0aDBfc3Ryb2tlIiBkPSJNMCAwdi0uNWgtLjVWMEgwem0yOCAwaC41di0uNUgyOFYwem0wIDExMnYuNWguNXYtLjVIMjh6bS0yOCAwaC0uNXYuNUgwdi0uNXpNMCAuNWgyOHYtMUgwdjF6TTI3LjUgMHYxMTJoMVYwaC0xem0uNSAxMTEuNUgwdjFoMjh2LTF6TS41IDExMlYwaC0xdjExMmgxeiIvPjwvZGVmcz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/About/ScrollBar/bar.svg
// module id = 671
// module chunks = 213534597649335